import { ResponsiveBar } from '@nivo/bar';
import React, { useMemo } from 'react';
import { ChartBase } from 'src/features/boards/components/Analytics/ChartBase';

const transformData = (originalData) => {
  const transformedData: any[] = [];

  for (const key in originalData) {
    const sprintData = originalData[key];

    for (const date in sprintData.data) {
      const dayData = sprintData.data[date];
      const estimated = dayData.incomplete || 0;

      transformedData.push({
        date: formatDate(new Date(date)),
        estimate: estimated.toString(),
      });
    }
  }

  return transformedData;
};

const formatDate = (date) => {
  const month = (date.getMonth() + 1).toString().padStart(2, '0');
  const day = date.getDate().toString().padStart(2, '0');
  return `${month}/${day}`;
};

export const BurnDownChart = ({
  data,
  members,
  datepicker,
}: {
  data: any[];
  members: any[] | undefined;
  datepicker?: React.ReactElement;
}) => {
  const sum = 0;
  // const dataBar = formattedGroupData.map((i) => {
  //   sum += i.estimate;
  //   return {
  //     date: new Date(i.date).toLocaleString('en-IN', { day: 'numeric', month: 'numeric' }),
  //     estimate: totalEstimatesFromTasks - sum,
  //   };
  // });

  const dataBar = transformData(data);

  const chartObject = [
    {
      type: 'bar',
      chart: (
        <ResponsiveBar
          data={dataBar as any}
          keys={['estimate']}
          indexBy="date"
          margin={{ top: 50, right: 50, bottom: 50, left: 60 }}
          padding={0.8}
          valueScale={{ type: 'linear' }}
          indexScale={{ type: 'band', round: true }}
          colors={['#254DDA']}
          borderRadius={5}
          axisTop={null}
          axisRight={null}
          axisLeft={{
            format: (e) => Math.floor(e) === e && e,
            legend: 'Story points',
            legendOffset: -50,
            legendPosition: 'middle',
            tickPadding: 10,
            tickRotation: 0,
          }}
          enableLabel={false}
          labelSkipWidth={12}
          labelSkipHeight={12}
          tooltip={({ data }) => (
            <div
              style={{
                padding: 8,
                background: '#ffffff',
                fontSize: '12px',
                boxShadow: '0px 2px 8px rgba(19, 23, 32, 0.16)',
                borderRadius: '5px',
              }}
            >
              <p>{data.date}</p>
              <p style={{ fontWeight: 500 }}>{data.estimate} completed points</p>
            </div>
          )}
          axisBottom={{
            legend: 'Date',
            legendOffset: 46,
            legendPosition: 'middle',
            tickPadding: 10,
            tickRotation: 0,
            tickValues: 'every 1',
          }}
          role="application"
          ariaLabel="Tasks count by assigned to"
          barAriaLabel={function (e) {
            return e.id + ': ' + e.formattedValue + ' in country: ' + e.indexValue;
          }}
        />
      ),
    },
  ];

  return (
    <ChartBase
      data={chartObject}
      noData={dataBar.length === 0}
      title="📉&nbsp;Burn-down for selected files"
      emptyStateTextArray={[
        'No data to show',
        'Set task estimates and fill timesheet data for accurate burn-down data',
      ]}
      datepicker={datepicker}
    />
  );
};
